import StationService from '../services/StationService';
import RouteService from '../services/RouteService';
import TicketTypeService from '../services/TicketTypeService';
import RailcardsService from '../services/RailcardsService';
import AddressService from '../services/AddressService';
import PhotocardService from '../services/PhotocardService';

export async function enrichFavouriteDeliveryResponse(delivery, user) {
    if (!delivery) {
        return null;
    }
    const { address: addressId, collectionLocation: collectionNlc } = delivery;

    const [address, collectionLocation] = await Promise.all([
        addressId ? AddressService.get(user, addressId) : Promise.resolve(null),
        collectionNlc ? StationService.get(collectionNlc) : Promise.resolve(null),
    ]);

    // Remap response.delivery.address => Fulfilment.storedAddress
    return {
        ...delivery,
        address: null,
        storedAddress: address,
        collectionLocation,
    };
}

export async function enrichFavouritesResponse(favourite, user) {
    const getRailcards = (railcards, fallback = []) => {
        return railcards
            ? Promise.all(railcards.map(code => RailcardsService.get(code)))
            : Promise.resolve(fallback);
    };

    const getStation = (nlc) => {
        return nlc ? StationService.get(nlc) : Promise.resolve(null);
    };

    const getPhotocard = (photocardNumber) => {
        return photocardNumber
            ? PhotocardService.getByNumber(user, photocardNumber)
            : Promise.resolve(null);
    };

    const [
        destination,
        origin,
        route,
        ticketType,
        railcards,
        outwardPlusBusOrigin,
        outwardPlusBusDestination,
        returnPlusBusOrigin,
        returnPlusBusDestination,
        delivery,
        photocard,
    ] = await Promise.all([
        getStation(favourite.destination),
        getStation(favourite.origin),
        RouteService.get(favourite.route),
        TicketTypeService.get(favourite.ticketType),
        getRailcards(favourite.railcards),
        getStation(favourite.outwardPlusBusOrigin),
        getStation(favourite.outwardPlusBusDestination),
        getStation(favourite.returnPlusBusOrigin),
        getStation(favourite.returnPlusBusDestination),
        enrichFavouriteDeliveryResponse(favourite.delivery, user),
        getPhotocard(favourite.photocard),
    ]);

    // Remap response.dateLastUsed => Fulfilment.lastUsed
    const lastUsed = favourite.dateLastUsed;

    return {
        ...favourite,
        destination,
        origin,
        route,
        ticketType,
        railcards,
        outwardPlusBusOrigin,
        outwardPlusBusDestination,
        returnPlusBusOrigin,
        returnPlusBusDestination,
        delivery,
        photocard,
        lastUsed,
    };
}

export function getPlusBus (orderTrip) {
  let plusBus = {};

  if (orderTrip.hasPlusBus()) {
      const plusBusFares = orderTrip.getPlusBus();

      const getPlusBusStation = (direction, terminal) => plusBusFares.getIn([direction, terminal, terminal, 'nlc']);
      Object.assign(plusBus, {
          outwardPlusBusOrigin: getPlusBusStation('outward', 'origin'),
          outwardPlusBusDestination: getPlusBusStation('outward', 'destination'),
          returnPlusBusOrigin: getPlusBusStation('return', 'origin'),
          returnPlusBusDestination: getPlusBusStation('return', 'destination'),
      });
  }

  return plusBus;
}
